import Master from 'components/helper/Master'
import React from 'react'

function LanguageMaster() {
  return (
    <Master name={{name:"Language Master"}} getUrl={"/Admin/getalllanguage"} deleteUrl={"/Admin/deletelanguage"} updateurl={"/Admin/Updatelanguage"}addurl={"/Admin/addlanguage"} id={'LanguageId'}/>
  )
}

export default LanguageMaster;